import { Fragment } from "react";
import { Card } from "react-bootstrap";
import CardFrame from "./../Components/layout/CardFrame";
import ProductItemCard from "../Components/Home/ProductItemCard";
import SearchCustomer from "../Components/Home/CustomerList";

const HomePage = () => {
  return (
    <Fragment>
      {/* <div className="row page-titles mx-0">
        <div className="col p-md-0">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="javascript:void(0)">Dashboard</a>
            </li>
            <li className="breadcrumb-item active">
              <a href="javascript:void(0)">Home</a>
            </li>
          </ol>
        </div>
      </div> */}
      <div className="container-fluid mt-3">
        {/* <CardFrame className="card-custom">
          <ProductItemCard />
        </CardFrame> */}
        <CardFrame>
          <SearchCustomer />
        </CardFrame>
      </div>
    </Fragment>
  );
};

export default HomePage;
